module.exports = __webpack_public_path__ + "img/img103.18113b8b.svg";